<template>
  <section
    class="provider-site pt-2 pt-md-4">
    <provider-site-prerender
      v-if="isPrerender">
    </provider-site-prerender>
    <template
      v-else>
      <!-- provider site mobile -->
      <provider-site-mobile
        v-if="$vuetify.breakpoint.smAndDown">
      </provider-site-mobile>
      <!-- provider site desktop -->
      <provider-site-desktop
          v-if="$vuetify.breakpoint.mdAndUp">
      </provider-site-desktop>
    </template>
  </section>
</template>

<script>

const ProviderSiteMobile = () => import(/* webpackChunkName: "providersitemobile" */ '@/components/Providers/ProviderSiteMobile');
const ProviderSiteDesktop = () => import(/* webpackChunkName: "providersitedesktop" */ '@/components/Providers/ProviderSiteDesktop');
const ProviderSitePrerender = () => import(/* webpackChunkName: "providersiteprerender" */ '@/components/Providers/ProviderSite/Prerender');

export default {
  name: 'ProviderSite',
  computed: {
    isPrerender() {
      const { prerender } = this.$route.query;
      return prerender !== null && prerender !== undefined;
    },
  },
  components: {
    ProviderSiteMobile,
    ProviderSiteDesktop,
    ProviderSitePrerender,
  },
};
</script>

<style lang="scss">

  .provider-site {
    .banner {
      min-height: 200px;
      background-image: linear-gradient(to left bottom,
        #5e7697, #506c8e, #426285, #34587c, #234e73);
      opacity: 0.5;
    }

  }
</style>
